import { render, staticRenderFns } from "./ListTags.vue?vue&type=template&id=27181fd8&scoped=true&"
import script from "./ListTags.vue?vue&type=script&lang=js&"
export * from "./ListTags.vue?vue&type=script&lang=js&"
import style0 from "./ListTags.vue?vue&type=style&index=0&id=27181fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27181fd8",
  null
  
)

export default component.exports